import React from "react";
import { blogPosts } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function BlogSection() {
  return (
    <section className="section bg-[#F5EFE6]">
      <div className="container-y">
        <div className="text-center mb-14">
          <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
            Journal
          </p>
          <h2 className="font-serif-y text-3xl md:text-5xl text-[#1a1a1a]">
            The Gold Standard: Behind the Shine
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {blogPosts.map((p) => (
            <a
              key={p.title}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              className="group flex flex-col bg-white border border-[#EAE3D8] overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-7 flex flex-col gap-4 flex-1">
                <h3 className="font-serif-y text-xl md:text-2xl text-[#1a1a1a] leading-snug group-hover:text-[#C9A961] transition-colors">
                  {p.title}
                </h3>
                <p className="font-sans-y text-[14px] text-[#555] leading-relaxed">{p.excerpt}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 font-sans-y text-[11px] tracking-[0.25em] uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-0.5 w-fit group-hover:text-[#C9A961] group-hover:border-[#C9A961] transition-colors">
                  Continue reading <ArrowUpRight size={12} />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
